export default "__VITE_ASSET__BjdQZmwt__"